import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export const AuthRouteHandler = () => {
  const { isPasswordRecovery } = useAuth();
  const navigate = useNavigate();
  const handledRecovery = useRef(false);

  useEffect(() => {
    if (isPasswordRecovery && !handledRecovery.current) {
      handledRecovery.current = true;
      navigate('/profile', { replace: true });
    } else if (!isPasswordRecovery) {
      handledRecovery.current = false;
    }
  }, [isPasswordRecovery, navigate]);

  return null;
};
